/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { TenantContactEvent } from './TenantContactEvent.js';
import {
    TenantContactEventFromJSON,
    TenantContactEventFromJSONTyped,
    TenantContactEventToJSON,
} from './TenantContactEvent.js';

/**
 * 
 * @export
 * @interface GetTenantContactEventsResponse
 */
export interface GetTenantContactEventsResponse {
    /**
     * 
     * @type {Array<TenantContactEvent>}
     * @memberof GetTenantContactEventsResponse
     */
    data?: Array<TenantContactEvent>;
    /**
     * 
     * @type {number}
     * @memberof GetTenantContactEventsResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTenantContactEventsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTenantContactEventsResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetTenantContactEventsResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetTenantContactEventsResponse interface.
 */
export function instanceOfGetTenantContactEventsResponse(value: object): boolean {
    return true;
}

export function GetTenantContactEventsResponseFromJSON(json: any): GetTenantContactEventsResponse {
    return GetTenantContactEventsResponseFromJSONTyped(json, false);
}

export function GetTenantContactEventsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTenantContactEventsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(TenantContactEventFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetTenantContactEventsResponseToJSON(value?: GetTenantContactEventsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(TenantContactEventToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

